import { useAppSelector } from '@user/store/hooks'
import { FEATURES } from '@sales-center/common/tenantFeatures'
import { selectTenantFeatureById } from '@user/store/tenantFeatures'

export function usePestPacPinsEnabled() {
  const pestPacPins = useAppSelector((state) =>
    selectTenantFeatureById(state, FEATURES.PestPacPins),
  )

  return pestPacPins?.enabled ?? false
}
